// 飞行模式
export default {
    'FM1': '未飞行',
    'FM2': '起飞模式',
    'FM3': '降落模式',
    'FM4': '返航模式',
    'FM5': '原路返航模式',
    'FM6': '归航模式',
    'FM7': '指点模式',
    'FM8': '环绕模式',
    'FM9': '增稳模式',
    'FM10': '定高模式',
    'FM11': '定点模式',
    'FM12': '自动航线',
    'FM13': 'AB点模式',
}